import { useTranslation } from 'react-i18next';
import { array, number, string } from 'yup';

const useAddJourneySchema = () => {
  const { t } = useTranslation();
  const requiredLabel = t('form_errors_required');

  return {
    name: string().required(requiredLabel),
    sfmcJourneyApiKey: string(),
    format: string().required(requiredLabel),
    timeInHour: number().required(requiredLabel),
    marketDefaults: array().min(1, requiredLabel),
    reminderType: string(),
    channel: string().required(requiredLabel),
  };
};

export default useAddJourneySchema;
